
// Constants for numeric field configuration
export const NUMERIC_FIELD_CONFIG = {
    maxValue: 500,
    fields: {
      stopTime: {
        label: 'Stop Time',
        unit: 'mins',
        hasUnit: true
      },
      maxDelay: {
        label: 'Max Delay',
        unit: 'mins',
        hasUnit: true
      },
      moveablePalletCount: {
        label: 'Moveable Pallet',
        unit: null,
        hasUnit: false
      }
    }
  };
  
export const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
  
export const ENABLE_GEOFENCE = false; //Hide geofence controls in Edit Customer Form Map for FFE for now.